import { useSelector, useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import gridViewSelectors from 'common/components/grid-view/controllers/selectors';
import * as memberMaintenanceServices from 'services/memberMaintenance';
import * as globalActions from '@redux/global/actions';
import { useDispatchReloadPage } from 'hooks/useReloadPage';
import RibbonButton from 'common/components/button/RibbonButton';
import { RibbonSection } from 'common/components';
import { SafetyOutlined } from '@ant-design/icons';
import Messages from 'i18n/messages/maintenance';
import { FormattedMessage } from 'react-intl';
import { notification } from 'antd';
import dialogFunction from 'common/components/dialog-function/DialogFunction';

const ResetMFAPhoneNumber = () => {
  const dispatch = useDispatch();

  const selectedUsers = useSelector(
    gridViewSelectors.makeSelectItemsSelection()
  );

  const reloadPage = useDispatchReloadPage();

  const resetMFAMutation = useMutation({
    mutationFn: (userId) =>
      memberMaintenanceServices.resetMFAPhoneNumber({
        userId
      }),

    onSuccess: (res) => {
      if (res?.isSuccess) {
        notification.success({
          message: res?.message,
          top: 50
        });

        reloadPage();

        setTimeout(() => {
          dispatch(globalActions.updateReloadPage(false));
        }, 100);

        return;
      }

      notification.error({
        message:
          'Require MFA is set to False for this user. Please enable the Require MFA option before using MFA Re-Registration.',
        top: 50
      });
    },

    onError: () => {
      notification.error({
        message: 'Failed to reset MFA phone number.',
        top: 50
      });
    }
  });

  const resetMFA = () => {
    if (selectedUsers.length === 0) {
      notification.error({
        message: 'Should choose users to reset!',
        top: 50
      });

      return;
    }

    const userId = selectedUsers[0];

    resetMFAMutation.mutate(userId);
  };

  const confirmResetMFA = () => {
    dialogFunction({
      type: 'warn',
      content:
        "Are you sure you want to reset this user's MFA registration? The currently registered MFA phone number will be removed and the user will be required to register a new phone number during their next login.",
      okText: 'OK',
      cancelText: 'Cancel',
      onOk: resetMFA
    });
  };

  return (
    <RibbonSection>
      <RibbonButton
        disabled={selectedUsers.length !== 1 || resetMFAMutation.isPending}
        onClick={confirmResetMFA}
        icon={<SafetyOutlined />}
        label={<FormattedMessage {...Messages.resetMFA} />}
      />
    </RibbonSection>
  );
};

export default ResetMFAPhoneNumber;
